const pxToRem = (value: number) => {
  return `${value / 16}rem`;
};

const pixelToRem = (value: string) => {
  const d = parseInt(value.replace('px', ''));
  return `${d / 16}rem`;
};

export { pxToRem, pixelToRem };
